<div class="wrapper">
  <app-dashboard>
    <div class="page">
      
        <div class="top-section">
            <div class="button"><app-button-fill [action]="addWebhookModal" buttonText=" Add Webhook Configuration"></app-button-fill></div>
        </div>
        <div class="second-section">


      
           
            <!-- <app-modal-wrapper title="Dynamic Modal">
                
                <p>This is the content of the dynamic modal.</p>
                <button (click)="closeModal()">Close Modal</button>
              </app-modal-wrapper> -->
              <app-webhook-table [processLoading]="fetchingData" [data]="webhooks" [action]="showSingleWebhook" ></app-webhook-table>
            <!-- <div class="table">
                <app-table [fetchingData]="fetchingData" [action]="showSingleWebhook" [headers]="tableHeaders" [data]="tableData"></app-table>
            </div> -->
        </div>
    </div>
    </app-dashboard>
</div>
<!-- <app-modal [title]="'Add Webhook Configuration'" *ngIf="isModalOpen">
    <div class="form-container">
        <div class="form-holder"><app-input></app-input></div>
        <div class="form-holder"><app-select></app-select></div>
        <div class="form-holder"><app-input></app-input></div>
        <div class="form-holder"><app-dropdown label="Select Color" [options]="colorOptions" [(selectedValue)]="selectedColor"></app-dropdown></div>
        <div class="form-holder"><app-input></app-input></div>
        <div class="form-holder"><app-dropdown label="Select Color" [options]="colorOptions" [(selectedValue)]="selectedColor"></app-dropdown></div>
    </div>
    <button (click)="closeModal()">Close Modal</button>
  </app-modal> -->

  <!-- <app-dropdown
        label="Select Color"
        [options]="colorOptions"
        [(selectedValue)]="selectedColor"
      ></app-dropdown>
  
      <div *ngIf="selectedColor">
        You selected: {{ selectedColor }}
      </div> -->
      <!-- <button (click)="openModal()">Open Modal</button> -->
    <app-modal [title]="modalTitle" [isOpen]="isModalOpen" (closeModalEvent)="closeModal()">
      <p-toast></p-toast>
      <!-- Dynamic content goes here -->
      <div class="form-container">
        <div class="sub-form full-width">
            <div class="input-holder half-width">
        <div class="form-holder full-width"><app-input (dataEvent)="name($event)" label="Name" placeholder="Ameh & Sons"></app-input></div>

        <div class="form-holder half-width"><app-dropdown label="Webhook Type" [options]="typeOptions" [selectedValue]="selectedType" (selectionChanged)="onSelectedType($event)"></app-dropdown></div>

        <div *ngIf="selectedType == 'Receiving'" class="form-holder half-width"><app-input (dataEvent)="webhookUrl($event)" label="Webhook URL" placeholder="Enter URL"></app-input></div>

        <div class="form-holder"><app-dropdown label="Resend Webhook" [options]="resendOptions" [selectedValue]="selectedResend" (selectionChanged)="onSelectedResend($event)"></app-dropdown></div>

        <div *ngIf="selectedResend == 'true'" class="form-holder"><app-dropdown label="Resend Duration" [options]="timeOptions" [selectedValue]="selectedTime" (selectionChanged)="onSelectedTime($event)"></app-dropdown></div>

        <!-- <div class="form-holder"><app-multi-select-checkbox [options]="acceptableErrors" [selectedValues]="errors" (selectionChanged)="onSelectErrors($event)"></app-multi-select-checkbox></div> -->

        <div class="form-holder full-width"><app-input (dataEvent)="newErrors($event)" label="Acceptable Error(s)" placeholder="400,404,500"></app-input></div>
    </div>
    </div>
    </div>
    <div class="button"><app-button-fill [processLoading]="isLoading" [action]="createWebhook" buttonText="Add to Configurations"></app-button-fill></div>

    <!-- <div class="button"><app-button-outline [action]="closeModal"  buttonText="Close Modal"></app-button-outline></div> -->

    </app-modal>

    <!-- <button (click)="openModal2()">Open Modal2</button> -->
    <app-modal [title]="modalTitle2" [isOpen]="isModalOpen2" (closeModalEvent)="closeModal2()">
        <!-- Dynamic content goes here -->
        <p-toast></p-toast>
        <div class="form-container">
            <div class="sub-form full-width">
                <div class="input-holder half-width">
             <div class="form-holder full-width"><app-input (dataEvent)="onUpdatedName($event)" [disabled]=true [inputData]=this.formModal.name label="Name"></app-input></div>

             <div *ngIf="this.formModal.senderUrl !== ''" class="form-holder full-width"><app-copy-text-single-line [text]=this.formModal.senderUrl label="Sender URL"></app-copy-text-single-line></div>

             <div class="form-holder half-width"><app-dropdown label="Webhook Type" [options]="typeOptions" [selectedValue]=this.formModal.type (selectionChanged)="onUpdatedType($event)"></app-dropdown></div>

             <div *ngIf="this.formModal.type == 'Receiving'" class="form-holder half-width"><app-input (dataEvent)="onUpdatedUrl($event)" [inputData]=this.formModal.webhookUrl label="Webhook URL"></app-input></div>

             <div class="form-holder"><app-dropdown label="Resend Webhook" [options]="resendOptions" [selectedValue]=this.formModal.resend (selectionChanged)="onUpdatedResend($event)"></app-dropdown></div>

           <div *ngIf="this.formModal.resend == 'true'" class="form-holder"><app-dropdown label="Resend Duration" [options]="timeOptions" [selectedValue]=this.duration (selectionChanged)="onUpdatedResendDuration($event)"></app-dropdown></div>

            <!-- <div class="form-holder"><app-multi-select-checkbox [options]="acceptableErrors" [selectedValues]=this.formModal.acceptableError (selectionChanged)="onUpdatedErrors($event)"></app-multi-select-checkbox></div> -->
        </div>
        </div>
        </div>
    <div class="button"><app-button-fill [processLoading]="isLoading" [action]="patchWebhook" buttonText="Update Configurations"></app-button-fill></div>
      <button (click)="closeModal2()">Close Modal</button>
    </app-modal>

  